export default (id: string) => btoa(`gid://shopify/ProductVariant/${id}`)
